export const providers = [
  { label: "SInvoice", value: "viettel" },
  { label: "xCyber", value: "xcyber" },
];
